'use strict'

export const bancos = [
    "001 - Banco do Brasil",
    "003 - Banco da Amazônia",
    "004 - Banco do Nordeste",
    "021 - Banestes",
    "025 - Banco Alfa",
    "027 - Besc",
    "029 - Banerj",
    "031 - Banco Beg",
    "033 - Banco Santander Banespa",
    "036 - Banco Bem",
    "037 - Banpará",
    "038 - Banestado",
    "039 - BEP",
    "040 - Banco Cargill",
    "041 - Banrisul",
    "044 - BVA",
    "045 - Banco Opportunity",
    "047 - Banese",
    "062 - Hipercard",
    "063 - Ibibank",
    "065 - Lemon Bank",
    "066 - Banco Morgan Stanley Dean Witter",
    "069 - BPN Brasil",
    "070 - Banco de Brasília – BRB",
    "072 - Banco Rural",
    "073 - Banco Popular",
    "074 - Banco J. Safra",
    "075 - Banco CR2",
    "076 - Banco KDB",
    "077 - Banco Inter",
    "096 - Banco BMF",
    "104 - Caixa Econômica Federal",
    "107 - Banco BBM",
    "116 - Banco Único",
    "151 - Nossa Caixa",
    "175 - Banco Finasa",
    "184 - Banco Itaú BBA",
    "204 - American Express Bank",
    "208 - Banco Pactual",
    "212 - Banco Matone",
    "213 - Banco Arbi",
    "214 - Banco Dibens",
    "217 - Banco Joh Deere",
    "218 - Banco Bonsucesso",
    "222 - Banco Calyon Brasil",
    "224 - Banco Fibra",
    "225 - Banco Brascan",
    "229 - Banco Cruzeiro",
    "230 - Unicard",
    "233 - Banco GE Capital",
    "237 - Bradesco",
    "237 - Next",
    "241 - Banco Clássico",
    "243 - Banco Stock Máxima",
    "246 - Banco ABC Brasil",
    "248 - Banco Boavista Interatlântico",
    "249 - Investcred Unibanco",
    "250 - Banco Schahin",
    "252 - Fininvest",
    "254 - Paraná Banco",
    "260 - Nubank",
    "263 - Banco Cacique",
    "265 - Banco Fator",
    "266 - Banco Cédula",
    "300 - Banco de la Nación Argentina",
    "318 - Banco BMG",
    "320 - Banco Industrial e Comercial",
    "341 - Itau",
    "347 - Sudameris",
    "351 - Banco Santander",
    "353 - Banco Santander Brasil",
    "356 - ABN Amro Real",
    "366 - Banco Societe Generale Brasil",
    "370 - Banco WestLB",
    "376 - JP Morgan",
    "389 - Banco Mercantil do Brasil",
    "394 - Banco Mercantil de Crédito",
    "399 - HSBC",
    "409 - Unibanco",
    "412 - Banco Capital",
    "422 - Banco Safra",
    "453 - Banco Rural",
    "456 - Banco Tokyo Mitsubishi UFJ",
    "464 - Banco Sumitomo Mitsui Brasileiro",
    "477 - Citibank",
    "479 - Itaubank (antigo Bank Boston)",
    "487 - Deutsche Bank",
    "488 - Banco Morgan Guaranty",
    "492 - Banco NMB Postbank",
    "494 - Banco la República Oriental del Uruguay",
    "495 - Banco La Provincia de Buenos Aires",
    "505 - Banco Credit Suisse",
    "600 - Banco Luso Brasileiro",
    "604 - Banco Industrial",
    "610 - Banco VR",
    "611 - Banco Paulista",
    "612 - Banco Guanabara",
    "613 - Banco Pecunia",
    "623 - Banco Panamericano",
    "626 - Banco Ficsa",
    "630 - Banco Intercap",
    "633 - Banco Rendimento",
    "634 - Banco Triângulo",
    "637 - Banco Sofisa",
    "638 - Banco Prosper",
    "643 - Banco Pine",
    "652 - Itaú Holding Financeira",
    "653 - Banco Indusval",
    "654 - Banco A.J. Renner",
    "655 - Banco Votorantim",
    "707 - Banco Daycoval",
    "719 - Banif",
    "721 - Banco Credibel",
    "734 - Banco Gerdau",
    "735 - Banco Neon",
    "738 - Banco Morada",
    "739 - Banco Galvão de Negócios",
    "740 - Banco Barclays",
    "741 - BRP",
    "743 - Banco Semear",
    "745 - Banco Citibank",
    "746 - Banco Modal",
    "747 - Banco Rabobank International",
    "748 - Banco Cooperativo Sicredi",
    "749 - Banco Simples",
    "751 - Dresdner Bank",
    "752 - BNP Paribas",
    "753 - Banco Comercial Uruguai",
    "755 - Banco Merrill Lynch",
    "756 - Banco Cooperativo do Brasil",
    "757 - KEB"
]

export default class Bancos {    
}